<template>
    <div>
        <!--<v-tabs v-model="tab" class="ml-0 pl-0" show-arrows>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="(item, i) in tabs" :key="i" class="ml-0">
                <v-icon v-if="$vuetify.breakpoint.mdAndUp" class="mr-2">{{ item.icon }}</v-icon>
                {{ item.text }}
            </v-tab>
            <v-tab>
                <v-icon v-if="$vuetify.breakpoint.mdAndUp" class="mr-2">mdi-account-group</v-icon>
                Mannschaften
            </v-tab>
            <v-tab v-if="user.permissions.ergebnisdienst">
                <v-icon v-if="$vuetify.breakpoint.mdAndUp" class="mr-2">mdi-cloud-upload</v-icon>
                Excel-Import
            </v-tab>
        </v-tabs>-->
        <div ref="scrollBox"
             :class="[{'mx-6': $vuetify.breakpoint.mdAndUp && user.permissions.ergebnisdienst},
                      {'mx-10': $vuetify.breakpoint.smAndDown && user.permissions.ergebnisdienst}, 'tabContainer']">
            <div v-if="user.permissions.ergebnisdienst && $vuetify.breakpoint.mdAndDown">
                <div style="left: 0;" class="tabArrow white px-2" @click="scrollDiv('right')">
                    <v-icon>mdi-chevron-left</v-icon>
                </div>
                <div style="right: 0;" class="tabArrow white px-2" @click="scrollDiv('left')">
                    <v-icon>mdi-chevron-right</v-icon>
                </div>
            </div>
            <div :ref="'tab'+i" v-ripple v-for="(item, i) in tabs" :key="i" @click="selectTabVFor(i)"
                :class="[{'primary--text tabItemSelected': i === tab},
                         {'fullWidth': !user.permissions.ergebnisdienst && $vuetify.breakpoint.smAndUp},
                        'ml-0 tabItem d-inline-block px-4 pt-3 text-center text-truncate']">
                <v-icon v-if="$vuetify.breakpoint.smAndUp"
                        class="mr-1" :color="tab===i?'primary':''">
                    {{ item.icon }}
                </v-icon>
                {{item.text}}
            </div>
            <div ref="tab3" v-ripple v-if="user.permissions.ergebnisdienst" @click="selectTab(3)"
                 :class="[{'primary--text tabItemSelected': tab === 3},
                        'ml-0 tabItem d-inline-block px-4 pt-3 text-center text-truncate']">
                <v-icon v-if="$vuetify.breakpoint.smAndUp"
                        class="mr-1" :color="tab===3?'primary':''">
                    mdi-account-group
                </v-icon>
                MANNSCHAFTEN
            </div>
            <div ref="tab4" v-ripple v-if="user.permissions.ergebnisdienst" @click="selectTab(4)"
                 :class="[{'primary--text tabItemSelected': tab === 4},
                        'ml-0 tabItem d-inline-block px-4 pt-3 text-center text-truncate']">
                <v-icon v-if="$vuetify.breakpoint.smAndUp"
                        class="mr-1" :color="tab===4?'primary':''">
                    mdi-cloud-upload
                </v-icon>
                EXCEL-IMPORT
            </div>
        </div>
        <v-tabs-items v-model="tab" touchless>
            <v-tab-item><spiel-plan :saison="saison" :is-cup="isCup"></spiel-plan></v-tab-item>
            <v-tab-item :class="[{'pt-3': $vuetify.breakpoint.smAndDown},
                                {'pt-0': $vuetify.breakpoint.mdAndUp}, 'pb-2']">
                <div class="text-right pr-3 pb-2" v-if="$vuetify.breakpoint.mdAndUp">
                    <v-btn icon @click="printTabelle()"><v-icon>mdi-printer</v-icon></v-btn>
                </div>
                <tabelle v-if="!noRanking" :saison="saison"></tabelle>
                <v-alert v-else class="mx-3"  color="primary" border="left"
                         elevation="2" colored-border icon="mdi-information">
                    Für diese Liga wird keine Tabelle berechnet!</v-alert>
            </v-tab-item>
            <v-tab-item><schnittlisten :saison="saison"></schnittlisten></v-tab-item>
            <!--<v-tab-item v-if="user.permissions.ergebnisdienst || user.permissions.spielbericht">
                SPIELBERICHTE
            </v-tab-item>-->
            <v-tab-item v-if="user.permissions.ergebnisdienst">
                <saison-teams :saison="saison"></saison-teams>
            </v-tab-item>
            <v-tab-item v-if="user.permissions.ergebnisdienst">
                <saison-import :saison="saison" :is-cup="isCup"></saison-import>
            </v-tab-item>
        </v-tabs-items>
        <spiel-plan-delete-all-games :saison="saison">
        </spiel-plan-delete-all-games>
    </div>
</template>

<script>
    import SaisonTeams from "./saisonTeams";
    import SpielPlan from "./spielPlan";
    import Tabelle from "./tabelle";
    import Schnittlisten from "./schnittlisten";
    import SaisonImport from "./saisonImport";
    import SpielPlanDeleteAllGames from "./spielPlanDeleteAllGames";

    export default {
        components: {
            SpielPlanDeleteAllGames,
            SaisonImport,
            Schnittlisten,
            Tabelle,
            SpielPlan,
            SaisonTeams},
        name: "saison",
        props: ['saison', 'noRanking', 'isCup'],
        computed: {
            user(){ return this.$store.state.user; },
            tabs(){
                return !this.isCup ?[
                    {icon: 'mdi-view-list', text: 'SPIELPLAN'},
                    {icon: 'mdi-format-list-numbered', text: 'TABELLE'},
                    {icon: 'mdi-account-details', text: 'SCHNITTLISTEN'},
                ] : [
                    {icon: 'mdi-view-list', text: 'SPIELPLAN'},
                ]
            }
        },
        created(){
            if ( this.$store.state.local.printBackReset ) {
                this.tab = this.$store.state.local.printBackReset.tab ?
                    this.$store.state.local.printBackReset.tab : 0;
            }
            if ( this.$route.query.action && !this.$route.query.spielId ) {
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                delete q.action;
                this.$router.replace({path: p, query: q});
            }
        },
        data: () => ({
            tab: 0,
        }),
        methods: {
            selectTab(tab){
                const el = 'tab' + tab;
                this.$nextTick(() => this.$refs[el]
                    .scrollIntoView(false, {behavior: 'smooth', block: 'center'}));
                this.tab = tab;
            },
            selectTabVFor(tab){
                const el = 'tab' + tab;
                this.$nextTick(() => this.$refs[el][0]
                    .scrollIntoView(false, {behavior: 'smooth', block: 'nearest'}));
                this.tab = tab;
            },
            scrollDiv(direction){
                const left = direction === 'left' ? 2000 : 0;
                this.$nextTick(() => this.$refs.scrollBox
                    .scroll({left: left, behavior: 'smooth'}));
            },
            printTabelle(){
                this.$store.state.local.printContainer = {
                    headers: this.headers,
                    schnittliste: this.schnittliste,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    search: this.search,
                    location: this.location,
                    timeFrame: this.timeFrame,
                    saison: this.saison,
                    flags: this.flags,
                };
                this.$store.state.local.printContainer = {
                    saison: this.saison,
                };
                this.$router.push('/Ergebnisdienst/PrintTabelle');
            },
        },
        watch: {
            tab(){
                if ( this.$route.query.action ) {
                    window.history.back();
                }
            }
        }
    }
</script>

<style scoped>
    .tabItem {
        letter-spacing: 1.6px; font-weight: 500; color: #888;
        border-bottom: transparent 2px solid;
        padding-bottom: 10px;
    }
    .fullWidth { width: 33.33%}
    .tabItem:hover {background-color: #f9f9f9}
    .tabItemSelected {
        border-bottom: solid 2px #ff3a2d ;
    }
    .tabItemSelected:hover {background-color: #ffebee}
    .tabArrow {position: absolute; z-index: 5; padding-top: 10px; padding-bottom: 12px}

    .tabContainer {
        scroll-behavior: smooth;
        overflow-x: auto; white-space: nowrap;
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
    }
    .tabContainer::-webkit-scrollbar {
        display: none;  /* Safari and Chrome */
    }
</style>